import module from 'colaborador/module.js'
import template from './template.html'

export class ColaboradorIncapacidadesIncapacidadComponent {
  data
  catalogo = {
    tipoIncapacidad: [],
  }

  constructor ($q, $catalogos, ColaboradorIncapacidades) {
    this.$q = $q
    this.$catalogos = $catalogos
    this.ColaboradorIncapacidades = ColaboradorIncapacidades
  }

  $onInit () {
    this.promise = this.$q.all([
      this.ColaboradorIncapacidades.get(this.data.id_proyecto, this.data.id_colaborador)
        .then(({data}) => (this.periodos = data.filter((item) => item.indice !== this.data.indice))),
      this.$catalogos.get('tipoIncapacidad')
        .then((data) => (this.catalogo.tipoIncapacidad = data)),
    ])
  }

  calcularDuracion () {
    if ((!this.data.fecha_final || !this.data.fecha_inicial) && this.data.duracion) {
      this.calcularFecha()

      return
    }

    if (!this.data.fecha_final) {
      this.data.fecha_final = this.data.fecha_inicial
    }

    if (!this.data.fecha_inicial) {
      this.data.fecha_inicial = this.data.fecha_final
    }


    const timeDiff = Math.max(0, this.data.fecha_final.getTime() - this.data.fecha_inicial.getTime())

    this.data.duracion = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1
    // calcularImporte()
    this.validarPeriodo()
  }

  calcularFecha () {
    if ((!this.data.fecha_inicial && !this.data.fecha_final) || !this.data.duracion) return

    const duracion = ((this.data.duracion - 1) * 24 * 60 * 60 * 1000)

    if (this.data.fecha_inicial) {
      this.data.fecha_final = new Date(this.data.fecha_inicial.getTime() + duracion)
    } else {
      this.data.fecha_inicial = new Date(this.data.fecha_final.getTime() - duracion)
    }
    // this.calcularImporte()
    this.validarPeriodo()
  }

  /*calcularImporte() {
   this.data.importe = +(this.data.duracion * this.salarioDiario).toFixed(2)
   }*/

  validarPeriodo () {
    this.error = this.periodos.find((item) => {
      return (this.data.fecha_inicial >= item.fecha_inicial && this.data.fecha_inicial <= item.fecha_final)
        || (this.data.fecha_final >= item.fecha_inicial && this.data.fecha_final <= item.fecha_final)
    })
  }
}

module.component('colaboradorIncapacidadesIncapacidad', {
  controller: ColaboradorIncapacidadesIncapacidadComponent,
  template,
  bindings: {
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/colaborador/components/incapacidades/incapacidad/component.js